import Typography from 'APP/Converse/Typography'
import { TextInput } from 'react-native'
import Animated from 'react-native-reanimated'
import styled from 'styled-components/native'

export const DROPDOWN_HEIGHT = 328
export const INPUT_HEIGHT = 46

export const StyledAutocompleteContainer = styled.View`
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
  gap: 4px;
`

export const StyledValueLabel = styled(Typography).attrs({
  variant: 'bodyLarge',
})<{ hasIcon?: boolean }>`
  flex: 1;
  padding-left: ${({ theme, hasIcon }) => theme.metrics.baseMargin * 0.75 + (hasIcon ? 30 : 0)}px;
  padding-right: ${({ theme }) => theme.metrics.baseMargin * 0.75 + 30}px;
`

export const StyledDropdownContainer = styled.View`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`

export const StyledOption = styled.View<{
  selected: boolean
  highlighted: boolean
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  border-top-width: 1px;
  border-top-color: ${({ theme }) => theme.colors.elementsBorder};
  background-color: ${({ theme, selected, highlighted }) =>
    selected
      ? theme.colors.contrastElementBg
      : highlighted
      ? theme.colors.lightGray
      : theme.colors.elementsBg};
`

export const StyledInputContainer = styled.View`
  flex-direction: row;
  align-items: center;
  margin-top: -1px;
`

export const StyledInput = styled(TextInput)<{ hasIcon?: boolean }>`
  font-family: ${({ theme }) => theme.fonts.fontTypes.light};
  font-size: ${({ theme }) => theme.fonts.fontSize.large}px;
  line-height: ${({ theme }) => theme.fonts.lineHeight.large}px;
  height: ${INPUT_HEIGHT}px;
  color: ${({ theme }) => theme.colors.text};
  flex: 1;
  padding-vertical: 0;
  padding-left: ${({ theme, hasIcon }) => theme.metrics.baseMargin * 0.75 + (hasIcon ? 30 : 0)}px;
  padding-right: ${({ theme }) => theme.metrics.baseMargin * 0.75 + 30}px;
`

export const StyledValueContainer = styled.View`
  height: ${INPUT_HEIGHT}px;
  border: 1px solid ${({ theme }) => theme.colors.elementsBorder};
  background-color: ${({ theme }) => theme.colors.elementsBg};
  border-radius: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  flex-direction: row;
  align-items: center;
`

export const StyledDropdown = styled(Animated.View)`
  background-color: ${({ theme }) => theme.colors.elementsBg};
  border-radius: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  border-width: 1px;
  border-style: solid;
  shadow-color: #000;
`

export const StyledDropdownContent = styled.View`
  border-radius: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  flex: 1;
  overflow: hidden;
`

export const StyledCaption = styled(Typography).attrs({
  variant: 'bodySmall',
  color: 'dim',
})`
  margin-top: 4px;
`

export const StyledActivityIndicatorContainer = styled.View`
  position: absolute;
  right: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
  top: 0;
  bottom: 0;
  width: 20px;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`

export const StyledIconContainer = styled.View`
  position: absolute;
  left: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
  top: 0;
  bottom: 0;
  width: 20px;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`
